export default __webpack_public_path__ + "static/media/web-logo.a4bb4504.png";